import React, { useEffect, useState } from 'react'
import { getGoodTypesAllAPI } from '../../../api/products/goodTypeAPI'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { getGoodsAllAPI } from '../../../api/products/goodAPI'
import MySpiner from '../../UI/spiner/MySpiner'
import { getFactoryLinesByFactoryIdAPI } from '../../../api/factory/factoryLineAPI'

const FactoryLineSelectMain = ({ factoryId, required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [factoryLines, setFactoryLines] = useState([])

	const [loading, setLoading] = useState(false)

	useEffect(() => {
		getGoodTypes()
	}, [factoryId])

	useEffect(() => {
		valid()
	}, [required, value])

	const getGoodTypes = () => {
		setValueForm(null)
		setValue('')
		if (factoryId) {
			setLoading(true)
			getFactoryLinesByFactoryIdAPI({ factoryId }).then(data => {
				setFactoryLines(data)
				setLoading(false)
			}).catch(e => {
				// setError(responseError(e))
				setLoading(false)
				console.error(responseError(e))
			})
		}
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
	<>
		{
			loading ?
				<MySpiner />
			:
				<MySelect
					value={value}
					label="Лінія цеху"
					labelId="select__factory-label"
					id='select__factory'
					onChange = {e => {
						setValueForm(e)
						setValue(e)
						// setEvent({...event, categoryId: e})
					}}
					nameField='Лінія цеху'
					// sx={{width: '200px'}}
					options={
						factoryLines && factoryLines.length > 0 ? 
							factoryLines.map(factoryLine => {
								return {id: factoryLine.id, name: factoryLine.name}
							})
						: []	
					}
					// options={[]}
				/>
		}
	</>
  )
}

export default FactoryLineSelectMain